module.exports = __webpack_public_path__ + "static/assets/98fb2b55ace28b640bdb0f160a7109fd.png";